/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     成员管理 API 接口
  | @Version:   2020-02-12  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function relaterListApi(query) {
  return request({
    url: '?c=fam&a=relater&do=list',
    method: 'get',
    params: query
  })
}

export function wechatFanGetfewApi(query) {
  return request({
    url: '?c=up&a=member&do=getfew',
    method: 'get',
    params: query
  })
}

export function postRelaterApi(data) {
  return request({
    url: '?c=fam&a=relater&do=post',
    method: 'post',
    data: data
  })
}

export function delRelaterApi(data) {
  return request({
    url: '?c=fam&a=relater&do=delete',
    method: 'post',
    data: data
  })
}

export function noticeApi(data) {
  return request({
    url: '?c=fam&a=relater&do=notice',
    method: 'post',
    data: data
  })
}
